<div class="table-containe table-reponsive w-100" style="border: 1px solid #ccc;">
    <div class="table-responsive" style="max-height: 600px; overflow: auto;">
        <table mat-table [dataSource]="dataSource" class="mat-elevation-z8" id="htmlData" matSort>
            @for(column of gridInfoData; track column){
            <!-- action column -->
            <ng-container [matColumnDef]="column.fieldname">
                 <th mat-header-cell  *matHeaderCellDef class="text-center">
                    {{ currentLang ==='ar' ? column.displayaraname : column.displaylatname }}
                </th>
                @if (column.fieldname === 'action') {
                <td mat-cell *matCellDef="let row">
                    <button mat-flat-button color="primary" class="m-r-10" (click)="selectedItem(row)">{{'select' |
                        translate}}</button>
                </td>
                }
                @else if (column.fieldname == 'profilepic' || column.fieldtype == 'Image') {
                <!-- Image Column -->
                <td mat-cell *matCellDef="let row">
                    <div class="flex">
                        <div class="flex-shrink-0">
                            @if (row._entitydto[column.fieldname]) {
                            <img src="{{ row._entitydto[column.fieldname] }}" alt="user-image"
                                class="wid-50 border-50 image" />
                            } @else {
                            <img src="assets/images/user-placeholder.png" alt="user-image"
                                class="wid-50 border-50 image" />
                            }
                        </div>
                    </div>
                </td>
                }
                @else if (column.fieldname == 'phonenumber' || column.fieldname.toLowerCase().includes('mobile')) {
                <td mat-cell *matCellDef="let row" style="direction: ltr;">
                    {{ row._entitydto[column.fieldname] ? (row._entitydto[column.fieldname] | phoneFormat) :
                    '----' }}
                </td>
                }
                @else if(column.fieldtype === 'boolean' || column.fieldtype === 'bit') {
                <!-- boolean fields -->
                <td mat-cell *matCellDef="let row; let i = index">
                    <mat-checkbox [checked]="row._entitydto[column.fieldname]" [disableRipple]="true"
                        (click)="$event.preventDefault()">
                    </mat-checkbox>
                </td>
                }
                @else{
                <td mat-cell *matCellDef="let row">
                    <p class="w-100 px-3">{{row._entitydto[column.fieldname] ? row._entitydto[column.fieldname] : '----'}}</p>
                </td>
                }
            </ng-container>
            }

            <!-- definition of header and row  -->
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

            <!-- Row shown when there is no matching data. -->
            <tr class="mat-row" *matNoDataRow>
                <td class="mat-cell" [attr.colspan]="displayedColumns.length">{{'NoDatabyFilter' | translate}}</td>
            </tr>
        </table>
    </div>
</div>

<!-- paginator  -->
<mat-paginator [length]="totalcount" [pageSizeOptions]="[5, 10, 25]" showFirstLastButtons>
</mat-paginator>
<!-- end paginator region  -->